export * from './insuranceInfoReport.component';
export * from './insuranceInfoReport.service';
export * from './insuranceInfoWorkDetail';



// WEBPACK FOOTER //
// ./src/app/InsuranceInfoReport/index.ts